import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { IStyled } from '../../styles/types';

interface IProps extends IStyled {
  children: ReactNode;
}

const StyledList = styled.ul`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
  list-style: none;
  border-bottom: 1px solid ${theme.colors.secondary300};
`;

const TabList = ({ children, className }: IProps) => (
  <StyledList className={className}>{children}</StyledList>
);

export default TabList;
